import { FleekError } from './FleekError';

export class MigrationTokenInvalidError extends FleekError<object> {
  public name = 'MigrationTokenInvalidError';

  toString = () => 'Migration token is invalid or expired.';
}
